<!-- <div class="imgloader" *ngIf="loader">
    <img src="../../assets/img/loader.gif">
</div> -->

<div class="oi-login-main">
    <div class="row authentication mx-0">
    <div class="col-md-4 px-0 d-none d-md-block">
    <div class="login-bg">
    
    </div>
    </div>
    
    <div class="col-md-8">
    <div class="row d-flex justify-content-center align-items-center h-100">
    
    <div class="col-md-7">
    <div class="oi-login-form box box--stacked p-5">
    <div class="oi-login-logo"><img src="../../assets/img/logo-circle.svg"></div>
    <h2>Login to Your Account</h2>
    <form #loginForm="ngForm" (ngSubmit)="submitLogin()">
    <div class="oi-login-form-inner">
    <label class="oi-label1">Username or Email</label>
    <input type="text" class="form-control py-3.5 oi-field1" id="username" name="username" placeholder="Username or Email" [(ngModel)]="email"  #username="ngModel" required 
    (keydown)="updatetrim($event,'email')" autocomplete="current-password">
    <div *ngIf="username.invalid && (username.dirty || username.touched )" class="text-danger op-rquire1">
        <div class="oi-req-login" *ngIf="username.errors?.['required']">
            Username or Email is required
        </div>
    </div>    
    <label class="oi-label1 mt-3">Password</label>
    <div class="position-relative"> <input [type]="showPassword ? 'password' : 'text'" class="form-control py-3.5 oi-field1 " id="password" name="password" placeholder="Password" [(ngModel)]="userpassword"  #password="ngModel" required (keydown)="updatetrim($event,'userpassword')"> 
    <div *ngIf="password.invalid && (password.dirty || password.touched )" class="text-danger op-rquire1">
        <div class="oi-req-login" *ngIf="password.errors?.['required']">
            Password is required
        </div>
    </div>  
    <a href="javascript:void(0);" class="show-password-button text-muted" ><i (click)="showPassword = !showPassword" [ngClass]="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i></a> </div>
    
    <button type="submit" [disabled]="loginForm.invalid" class="btn btn-primary oi-btn1 oi-font-sz18 shadow mt-4" >Sign In</button>
    
    </div>
    </form>
    </div>
    </div>
    
    </div>
    </div>
    
    </div>
    </div>
    
    <p-toast></p-toast>